import hocify from 'hocify';
import { useIsFetching } from 'react-query';

export default hocify(() => {
  const fetching = useIsFetching();
  return { isFetching: Boolean(fetching) };
});
